export const REDUCER_KEY = "artists";
export const SET_FEATURED_ARTISTS = "SET_FEATURED_ARTISTS";
export const SET_ARTISTS = "SET_ARTISTS";
export const SET_FILTERED_ARTISTS = "SET_FILTERED_ARTISTS";
export const SET_SEARCH_ARTISTS = "SET_SEARCH_ARTISTS";
export const CLEAR_ARTISTS = "CLEAR_ARTISTS";
export const SET_ARTISTS_DEFAULTS = "SET_ARTISTS_DEFAULTS";
export const SET_SHOULD_LOAD_ARTISTS = "SET_SHOULD_LOAD_ARTISTS";
